import { Autocomplete, TextField, InputProps, InputLabelProps } from '@mui/material';
import { Supplier } from '../../../types';
import { INPUT_STYLE } from '../../../utils/styleHelpers';

export interface SupplierSelectionFormProps {
  supplier: Supplier | null;
  allSuppliers: Supplier[];
  supplierSearchQuery: string;
  classNames?: string;
  disabled?: boolean;
  handleInputChange: (e: React.SyntheticEvent<Element, Event>, value: string | null) => void;
  handleSupplierSelectionChange: (e: React.SyntheticEvent<Element, Event>, value: Supplier | string | null) => void;
  size?: 'medium' | 'small';
  InputProps?: Partial<InputProps>;
  InputLabelProps?: Partial<InputLabelProps>;
}

export const SupplierSelectionForm = ({
  supplier,
  allSuppliers,
  supplierSearchQuery,
  classNames,
  disabled = false,
  handleInputChange,
  handleSupplierSelectionChange,
  size = 'medium',
  InputProps: customInputProps,
  InputLabelProps: customInputLabelProps
}: SupplierSelectionFormProps) => {
  return (
    <div className={classNames}>
      <Autocomplete
        value={supplier}
        disabled={disabled}
        onInputChange={handleInputChange}
        inputValue={supplierSearchQuery}
        onChange={handleSupplierSelectionChange}
        onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
        options={allSuppliers.sort((a, b) => a.name.localeCompare(b.name))}
        freeSolo
        autoComplete={false}
        autoHighlight={false}
        autoSelect={false}
        getOptionLabel={(option: Supplier | string) => {
          return typeof option === 'string' ? option : option.name;
        }}
        size={size}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Supplier"
            inputProps={{
              ...params.inputProps,
              autoComplete: 'off'
            }}
            InputProps={{
              ...params.InputProps,
              style: { fontSize: '.875rem' },
              name: 'Supplier',
              ...customInputProps
            }}
            InputLabelProps={{
              ...params.InputLabelProps,
              ...customInputLabelProps
            }}
            className={INPUT_STYLE}
          />
        )}
        renderOption={(props, option) => (
          <li
            {...props}
            key={option.id}
            className="text-sm14 py-1 pl-4 cursor-pointer hover:bg-grey-1">
            {option.name}
          </li>
        )}
      />
    </div>
  );
};
